import { useRef, useState } from "react";

import BrandCarousel from "../BrandCarousal/BrandCarousel";
import { BrandLogoCard } from "./BrandLogoCard"
import { TestimonialCard } from "./TestimonialCard"

export const TrustedBrandsSection = () => {

  const logos = [
    "/images/Webp/Brand1.webp",
    "/images/Webp/Brand2.webp",
    "/images/Webp/Brand3.webp",
    "/images/Webp/Brand4.webp",
    "/images/Webp/Brand5.webp",
    "/images/Webp/Brand6.webp",
    
  ]
  const brandLogos = [
      "/images/Webp/Brand1.webp",
      "/images/Webp/Brand2.webp",
      "/images/Webp/Brand3.webp",
      "/images/Webp/Brand4.webp",
      "/images/Webp/Brand5.webp",
      "/images/Webp/Brand6.webp",
      "/images/Webp/Brand7.webp",
      "/images/Webp/Brand8.webp",
      "/images/Webp/Brand9.webp",
      "/images/Webp/Brand10.webp",
      "/images/Webp/Brand11.webp",
    ];

   
  const testimonials = [
    {
      name: "David Rafuse",
      title: "CEO/Founder, Blended Athletics Inc.",
      image: "/images/Webp/DaviRafusePP.webp",
      quote:
        "What Nelson is building with My Couponbook is exactly what local businesses need. It's a practical tool that drives real value for small businesses and strengthens the communities they serve. I've been impressed by Nelson's vision and the genuine impact this platform can have at the local level."
    },
    {
      name: "Joel George",
      title: "Owner, Fresco Italiano",
      image: "/images/Webp/Joel George.webp",
      quote:
        "Between high fees and subscriptions from other apps, it's hard for local shops to get ahead. The fact that My Couponbook gives us a free platform to connect directly with our neighborhood shows they actually want to be a true partner to small businesses, rather than just another monthly expense."
    },
    {
      name: "Dejhani Allen",
      title: "Owner, Brawta Jamaican Jerk Joint",
      image: "/images/Webp/Dejhani Allen.webp",
      quote:
        "Working with My Couponbook has been great! Nelson is supportive and friendly and accommodates our changes when needed. I would encourage any business to use the app!."
    },
    {
      name: "Jon Bowman",
      title: "Owner, Valley West Auto",
      image: "/images/Webp/JonBowman.webp",
      quote:
        "Instead of paying for expensive local ads, My Couponbook lets us connect with our customers and pass marketing savings directly to them. We stay busy, and they get the best value."
    },

    

    {
      name: "Robert Johnson",
      title: "Owner, The Corner Bakery",
      image: "/images/Webp/ellipse-3.webp",
      quote:
        "My Couponbook completely changed how we attract local customers. Instead of waiting for walk-ins, we now reach people at the right moment. The push notifications alone bring in new customers every week."
    },

    

    
  ]

   const sliderRef = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState(0);

  const handleScroll = () => {
  const slider = sliderRef.current;
  if (!slider) return; // ✅ fix

  const scrollLeft = slider.scrollLeft;
  const cardWidth = slider.offsetWidth * 1 + 16;
  const index = Math.round(scrollLeft / cardWidth);
  setActive(index);
};

const itemsPerSlide = 2;
  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? totalSlides - 1 : prev - 1
    );
  };

  return (
    <div>
      <div className="hidden lg:block px-6">
        <section className="w-full flex justify-center py-12 bg-[#FAFAFA]">

      <div className="w-full max-w-[1700px] px-6 text-center">

        {/* label */}
        <div className="flex justify-center items-center gap-3 text-gray-600 mb-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span>Built on Trust</span>
        </div>

        {/* heading */}
        <h2 className="text-[52px] font-medium text-gray-900 mb-6">
          Trusted by 100s of Local and
          <br />
          National Brands
        </h2>

        <p className="text-gray-600 text-[18px] max-w-[700px] mx-auto mb-12">
          Join hundreds of businesses using My Couponbook to build lasting relationships, retain customers, and grow their revenue
        </p>

        {/* logos */}
        {/* <div aria-hidden className="flex flex-wrap justify-center gap-6 mb-16">

          {logos.map((logo, index) => (
            <BrandLogoCard key={index} logo={logo} />
          ))}

        </div> */}

        <BrandCarousel />

        
        
      <div className="w-full max-w-6xl mx-auto py-12 relative">
      
      {/* Slider */}
      <div className="overflow-hidden rounded-3xl">
        <div
          className="flex transition-transform duration-500 "
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {Array.from({ length: totalSlides }).map((_, slideIndex) => (
            <div key={slideIndex} className="min-w-full px-4">
              <div className="grid md:grid-cols-2 gap-6">
                
                {testimonials
                  .slice(
                    slideIndex * itemsPerSlide,
                    slideIndex * itemsPerSlide + itemsPerSlide
                  )
                  .map((item, index) => (
                    <div
                      key={index}
                      className="bg-[#EDE7E7] rounded-3xl p-8 flex flex-col gap-4"
                    >
                      {/* Header */}
                      <div className="flex items-center gap-4">
                        <img
                          src={item.image}
                          alt=""
                          className="w-12 h-12 rounded-full"
                        />
                        <div>
                          <h3 className="font-semibold text-lg text-start">
                            {item.name}
                          </h3>
                          <p className="text-gray-500 text-sm text-start">
                            {item.title}
                          </p>
                        </div>
                      </div>

                      {/* Quote */}
                      <div className="mb-2">
                      <div className="text-red-500 text-3xl text-start">“</div>

                      <p className="text-gray-700 leading-relaxed text-start">
                        {item.quote}
                      </p></div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Buttons */}
      <button
        onClick={prevSlide}
        className="absolute -left-20 top-[180px] -translate-y-1/2 bg-white shadow-md px-6 py-2 rounded-full text-lg"
      >
        ←
      </button>

      <button
        onClick={nextSlide}
        className="absolute -right-20 top-[180px] -translate-y-1/2 bg-white shadow-md px-6 py-2 rounded-full text-lg"
      >
        →
      </button>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-12">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full ${
              current === index ? "bg-red-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>

        {/* button */}
         <a
                href="https://mycouponbook.ca/signup/form"
                 className="bg-red-600 text-white px-8 py-4 rounded-full text-[16px] hover:scale-105
    transition">

          Join the Community

        </a>

      </div>

    </section>
      </div>

       <div className="block lg:hidden">
        <section className="w-full flex justify-center py-12 bg-[#F9F0F0]">

      <div className="w-full max-w-[1700px]  text-center">

        {/* top label */}
        <div className="flex justify-center items-center gap-3 text-gray-600 mb-6 px-6">
          <span className="w-2.5 h-2.5 bg-red-600 rounded-full"></span>
          <span className="text-[16px]">Real Buying Signals</span>
        </div>

        {/* heading */}
        <h2 className="text-[30px] text-center text-gray-900 mb-4 leading-tight px-6">
          Trusted by 100s of Local
          <span className="text-gray-900"> and National Brands</span>
        </h2>

        {/* description */}
        <p className="text-gray-600 text-[12px] max-w-[720px] mx-auto mb-8 leading-relaxed px-6">
         Join hundreds of businesses using My Couponbook to build lasting relationships, retain customers, and grow their revenue
        </p>

        {/* logos */}
        <div className="flex flex-wrap justify-center gap-6 mb-16">

          <div aria-hidden className="hidden lg:block">
            {logos.map((logo, index) => (
            <BrandLogoCard key={index} logo={logo} />
          ))}
          </div>

           {/* <div className="block lg:hidden">
        <div aria-hidden className="
           
            
            -translate-x-1/2
            flex
            gap-[22px]
            items-center animate-marquee-reverse
          ">
              {[...brandLogos, ...brandLogos,...brandLogos,].map((src, i) => (
            // {brandLogos.map((src, i) => (
  
              <div
                key={i}
                className="
                  w-[88px]
                  h-[48px]
                  bg-white
                  rounded-[10px]
                  flex
                  items-center
                  justify-center
                  shadow-[0px_30px_80px_rgba(0,0,0,0.25)]
                "
              >
                <img
                  src={src}
                  className="max-h-[36px] max-w-[80px] object-contain"
                />
              </div>
  
            ))}
  
          </div>
      </div> */}

              <BrandCarousel />

        </div>

        {/* testimonials */}
        <div className="grid md:grid-cols-2 gap-8 justify-center mb-12 hidden lg:block ">

          {testimonials.map((item, index) => (
            <TestimonialCard key={index} {...item} />
          ))}

        </div>
        
      <div className="w-full max-[768px]:w-full block lg:hidden mb-12 px-4">

        {/* SLIDER */}
        <div 
          ref={sliderRef}
          onScroll={handleScroll}
          className="
          
            flex gap-4
            overflow-x-auto
            scroll-smooth
            no-scrollbar
            snap-x snap-mandatory
            pb-4
          "
        >
          {testimonials.map((item, index) => (
            <TestimonialCard key={index} {...item} />
          ))}
        </div>

        {/* INDICATORS */}
        <div className="flex justify-center gap-2 mt-4">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className={`
                w-2 h-2 rounded-full transition
                ${active === index ? "bg-red-600" : "bg-gray-300"}
              `}
            />
          ))}
        </div>

      </div>

        {/* button */}
         <a
                href="https://mycouponbook.ca/signup/form"
                 className="bg-red-600 text-white px-8 py-4 rounded-full text-[16px] hover:scale-105
    transition">

          Join the Community

        </a>

      </div>
<style>{`

          /* WORD ANIMATION */
          @keyframes wordAnimation {
          --s: 140px; /* size of the logo */
  --d: 13s; /* animation duration*/
  --n: 4; /* number of visible logos */
            0% {
              opacity:0;
              transform: translateY(40px);
            }

            15% {
              opacity:1;
              transform: translateY(0);
            }

            85% {
              opacity:1;
              transform: translateY(0);
            }

            100% {
              opacity:0;
              transform: translateY(-40px);
            }

          }

           @layer utilities {
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

          .animate-word {
            animation: wordAnimation 2.6s ease;
          }


          /* MARQUEE */
          @keyframes marquee {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          .animate-marquee {
            width:max-content;
            animation: marquee 55s linear infinite;
          }
            
          .animate-marquee-reverse {
            width:max-content;
            animation: marquee 10s linear infinite;
            animation-direction: reverse;
          }

          // .animate-marquee-reverse {
          //   width:max-content;
          //   animation: marquee 10s linear infinite;
          //   animation-direction: reverse;
          // }


          /* FIGMA TICKET STYLE BADGE */
          .ticket {

            position: relative;
            padding: 12px 28px;

            color:white;
            font-weight:500;
            font-size:15px;

            background: rgba(255,255,255,0.25);

            backdrop-filter: blur(10px);

            border: 1px solid rgba(255,255,255,0.35);

            clip-path: polygon(
              10px 0,
              calc(100% - 10px) 0,
              100% 10px,
              100% calc(100% - 10px),
              calc(100% - 10px) 100%,
              10px 100%,
              0 calc(100% - 10px),
              0 10px
            );

            box-shadow:
              0 8px 20px rgba(0,0,0,0.18);

            white-space:nowrap;
          }

        `}</style>
    </section>
      </div>
    </div>
    
  )
}